import Css from "./Customer.module.css";
import {
    Row,
    Col,
    Form,
    Button,
    Tab,
    Table,
    InputGroup,
    Spinner,
} from "react-bootstrap";
import { useEffect, useState } from "react";
import { AddCommar, ConvertDateToText } from "components/MyControl";
import ApiConection from 'api_ref/ApiConection';

export default function RegisterCustomerPayment2(
    { stepPage = 1,
        data,
        onChangeData = undefined,
        className,
        show_is_accept_agreement = false,
        disabled = false,
        error = '',
        parentLoading = false }) {
    const api = new ApiConection();

    const [discountCode, setDiscountCode] = useState(data?.discount_code);
    const [mastrCoupon, setMasterCoupon] = useState(undefined);
    const [loading, setLoading] = useState(false);
    const [couponError, setCouponError] = useState('');

    const checkDiscount = async () => {
        setCouponError('');
        setLoading(true);
        const response = await api.getData(`api/Coupon/${discountCode}/check-MasterCoupon`);
        if (response.status === true) {
            setMasterCoupon(response.data);
            if (disabled === false) {
                if (onChangeData !== undefined)
                    onChangeData({ target: { name: 'discount_code', value: discountCode } });
            }
        } else {
            setCouponError(response.message);
            setMasterCoupon(undefined);
            if (onChangeData !== undefined)
                onChangeData({ target: { name: 'discount_code', value: '' } });
        }
        setLoading(false);
    }

    if (Object.keys(data).length === 0) {
        return;
    }
    return (
        <>
            {data ? (
                <div className={`${Css.Register_customer_layout3} + ' w-100 ' +  ${className}`}>
                    <h6 className={`text-start mb-3 ${Css.colorh6}`}>สรุปรายการคำสั่งซื้อ</h6>
                    <Form.Group as={Col}>
                        <Form.Label className="me-2">ชื่อลูกค้า :</Form.Label>
                        <Form.Label className={Css.colorlabel}> {data?.payee_name}</Form.Label>
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label className="me-2">ที่อยู่ :</Form.Label>
                        <Form.Label className={Css.colorlabel}> {data?.payee_address}</Form.Label>
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label className="me-2">โทร :</Form.Label>
                        <Form.Label className={Css.colorlabel}> {data?.payee_tel}</Form.Label>
                    </Form.Group>
                    <Form.Group as={Col}>
                        <Form.Label className="me-2">เลขประจำตัวผู้เสียภาษี :</Form.Label>
                        <Form.Label className={Css.colorlabel + ' me-4'}> {data?.payee_tax_id}</Form.Label>
                        <Form.Label className="me-2">สาขา  :</Form.Label>
                        <Form.Label className={Css.colorlabel}> {data?.payee_branch}</Form.Label>
                    </Form.Group>
                    <table width={'100%'} className="mt-3 mb-3" border={1} cellPadding={4} cellSpacing={0}>
                        <tbody>
                            <tr>
                                <td className="text-center">
                                    <label>เลขที่คำสั่งซื้อ</label><br />
                                    <label>{data?.quontation_number}</label>
                                </td>
                                <td className="text-center">
                                    <label>วันที่สั่งซื้อ</label><br />
                                    <label>{ConvertDateToText(data?.create_date)}</label>
                                </td>
                                <td className="text-center">
                                    <label>เลขที่ลูกค้า</label><br />
                                    <label>{data?.register_number}</label>
                                </td>
                                <td className="text-center">
                                    <label>วันครบกำหนด</label><br />
                                    <label>{ConvertDateToText(data?.due_date)}</label>
                                </td>
                            </tr>
                        </tbody>

                    </table>
                    <table className={`table table-borderless table-summary`}>
                        <thead>
                            <tr>
                                <th className='text-start'>แพ็กเกจ</th>
                                <th className='col-4 text-end'>ราคา (บาท)</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data?.arr_package?.length > 0 &&
                                data?.arr_package?.map((obj, index) => (
                                    <tr key={index}>
                                        <td  ><pre>{(index + 1) + '. ' + obj.package_master_name_short}</pre></td>
                                        <td className=' text-end'>{AddCommar(Number(obj?.total?.toString().replace(',', '')).toFixed(2))}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>

                    {
                        data?.arr_package[0]?.package_type !== 'free' &&
                        <>
                            {
                                loading === true &&
                                <Spinner animation="border" variant="primary" />
                            }
                            {
                                disabled === false &&
                                loading === false && mastrCoupon === undefined &&
                                <>
                                    <InputGroup className={`${Css.body2}`} >
                                        <Form.Control type={'text'} name={'discount_code'}
                                            value={discountCode}
                                            placeholder="รหัสคูปอง"
                                            onChange={event => { setDiscountCode(event.target.value); setCouponError(''); }} />
                                        <Button type='button' className={Css.btnColor} onClick={(_) => checkDiscount()}>ใช้คูปอง</Button>
                                    </InputGroup>
                                    {
                                        couponError !== '' &&
                                        <Form.Text name={'discount_code_error'} className='text-danger'>{couponError}</Form.Text>
                                    }

                                </>
                            }
                            {
                                disabled === false &&
                                loading === false && mastrCoupon !== undefined &&
                                <>
                                    <hr className='mt-2 mb-2' />
                                    <Row>
                                        <Col>คุณได้รับส่วนลด {mastrCoupon.name} <a className='link' onClick={(_) => { setDiscountCode(''); setMasterCoupon(undefined); onChangeData({ target: { name: 'discount_code', value: '' } }); }} >(ใช้ภายหลัง)</a></Col>
                                        <Col sm={4} className='text-end font-color-privary pt-2'><label>{data?.discount}</label></Col>
                                    </Row>
                                </>
                            }
                            {
                                disabled === true && data?.discount > 0 &&
                                <>
                                    <hr className='mt-2 mb-2' />
                                    <Row>
                                        <Col>ส่วนลด จากโค้ดส่วนลด ({data.discount_code})</Col>
                                        <Col sm={4} className='text-end font-color-privary '><label>{AddCommar(Number(data?.discount?.toString().replace(',', '')).toFixed(2))}</label></Col>
                                    </Row>
                                </>
                            }
                            {
                                /*
                                  <hr className='mt-2 mb-2'/>
                                  <Row>
                                      <Col>
                                          <Form.Check  type={'checkbox'} className={`mt-2 mb-2 ${Css.body2}`} inline
                                          name="is_with_holding_tax"
                                          id="is_with_holding_tax"
                                          label="หักภาษี ณ ที่จ่าย 3%"
                                          checked={data?.is_with_holding_tax}
                                          onChange={event => onChangeData(event)}
                                          disabled={disabled}
                                          />
                                      </Col>
                                      <Col sm={4} className='text-end font-color-privary pt-2'>
                                          <label> { (data?.tax == 0)? '' : AddCommar(data?.tax)}</label>
                                      </Col>
                                  </Row>
                                */
                            }

                        </>
                    }

                    <hr className='mt-2 mb-4' />
                    <h6 className={`text-start m-0 mt-3 mb-4 text-blue-01`}>สรุปค่าบริการ</h6>
                    <Row className={`mb-2 text-blue-01`}>
                        <Col className='text-start'><span className='d-inline '>รวมมูลค่าสินค้า</span></Col>
                        <Col sm={7} className={`text-end`}>
                            <span className='mb-0 text-end'>{data?.arr_package?.length > 0 && AddCommar(data?.total?.toFixed(2))} บาท</span>
                            <Form.Text className='mt-0 pt-0' ></Form.Text>
                        </Col>
                    </Row>
                    <Row className={`mb-2 text-blue-01`}>
                        <Col className='text-start'><span className='d-inline '>ส่วนลด</span></Col>
                        <Col sm={7} className={`text-end`}>
                            <span className='mb-0 text-end'>{data?.arr_package?.length > 0 && AddCommar(data?.discount?.toFixed(2))} บาท</span>
                            <Form.Text className='mt-0 pt-0' ></Form.Text>
                        </Col>
                    </Row>
                    <Row className={`mb-2 text-blue-01`}>
                        <Col className='text-start'><span className='d-inline '>ราคาหลังหักส่วนลด</span></Col>
                        <Col sm={7} className={`text-end`}>
                            <span className='mb-0 text-end'>{data?.arr_package?.length > 0 && AddCommar(data?.net?.toFixed(2))} บาท</span>
                            <Form.Text className='mt-0 pt-0' ></Form.Text>
                        </Col>
                    </Row>
                    <Row className={`mb-2  text-blue-01`}>
                        <Col className='text-start'><span className='d-inline'>VAT {(data?.vat_rate * 100).toFixed(0)}%</span></Col>
                        <Col sm={6} className={`text-end`}>
                            <span className='mb-0 text-end'>{data?.arr_package?.length > 0 && AddCommar(data?.vat?.toFixed(2))} บาท</span>
                            <Form.Text className='mt-0 pt-0' ></Form.Text>
                        </Col>
                    </Row>
                    <Row className={`mb-4 text-blue-01 `}>
                        <Col className='text-start'><span className='d-inline'>จำนวนเงินสุทธิ</span></Col>
                        <Col sm={8} className={`text-end`}>
                            <span className='mb-0 text-end '>{data?.arr_package?.length > 0 && AddCommar(data?.grand_total?.toFixed(2))} บาท</span>
                            <Form.Text className='mt-0 pt-0' ></Form.Text>
                        </Col>
                    </Row>
                    <Row className={`mb-2  text-blue-01`}>
                        <Col className='text-start'><span className='d-inline'>หักภาษี ณ ที่จ่าย {(data?.tax_rate * 100).toFixed(0)}%</span></Col>
                        <Col sm={6} className={`text-end`}>
                            <span className='mb-0 text-end'>{data?.arr_package?.length > 0 && AddCommar(data?.tax?.toFixed(2))} บาท</span>
                            <Form.Text className='mt-0 pt-0' ></Form.Text>
                        </Col>
                    </Row>
                    <Row className={`mb-2 text-blue-01 fw-semibold`}>
                        <Col className='text-start'><span className='d-inline '>มูลค่ายอดชำระ</span></Col>
                        <Col sm={7} className={`text-end`}>
                            <span className='mb-0 text-end'>{data?.arr_package?.length > 0 && AddCommar(data?.grand_total_sub_withholding_tax?.toFixed(2))} บาท</span>
                            <Form.Text className='mt-0 pt-0' ></Form.Text>
                        </Col>
                    </Row>
                    {
                        <Row className='mt-3'>
                            <Col>
                                <i>
                                    ท่านสามารถหักภาษี ณ ที่จ่ายได้ ในกรณีที่ท่านมิได้หักไว้<br />
                                    ทางบริษัทฯ จะไม่รับผิดชอบในกรณีหักย้อนหลัง
                                </i>

                            </Col>
                        </Row>
                    }
                </div>
            ) : null}
        </>
    );
}